import css from 'styled-jsx/css';

const styles = css`span{padding:0 3px 0 2px;background-color:#c30;min-width:16px;height:16px;line-height:16px;border-radius:8px;text-align:center;color:#fff;font-size:.75rem;position:absolute;top:-6px;left:10px;z-index:10}`;

export default styles;